import { pdf } from "@react-pdf/renderer";
import { OrderConfirmationPDF } from "./OrderConfirmationPDF";
import toast from "react-hot-toast";
import { IProduct } from "../../models/productData.model";
import { CompanyInfo } from "../../models/quotationData.model";
import { CustomerOrder, OrderItem } from "../../models/Order.model";

export const handleOrderConfirmationPDF = async (
  orderItems: OrderItem[],
  customerInfo: CompanyInfo,
  customerOrders: CustomerOrder[],
  grandTotalForPdf: number,
  transportPrice: number = 0,
  discountPrice: number = 0
): Promise<void> => {
  try {
    if (orderItems.length <= 0) {
      toast.error("No items in the order.");
      return;
    }
    const pdfDocument = (
      <OrderConfirmationPDF
        orderItems={orderItems}
        customerInfo={customerInfo}
        customerOrders={customerOrders.map((order) => ({
          ...order,
          productId:
            typeof order.productId === "string"
              ? ({} as IProduct)
              : order.productId,
        }))}
        grandTotal={grandTotalForPdf}
        transportPrice={transportPrice}
        discountPrice={discountPrice}
      />
    );
    const pdfBlob = await pdf(pdfDocument).toBlob();
    const reader = new FileReader();
    reader.readAsDataURL(pdfBlob);

    const blob = new Blob([pdfBlob], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      if (iframe.contentWindow) {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      }
    };
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};